module.exports = __webpack_public_path__ + "img/history.3e84d1ee.png";